module.exports = __webpack_public_path__ + "static/media/ASIANPAINT_F1.486f50bb.txt";